import { useLeaseContractsList } from 'services/contracts/hooks/useLeaseContracts'
import { CONTRACT_STATUS } from 'services/contracts/contracts.consts'
import { useUserRoles, isOwner } from 'services/rbac/useUserRoles'
import { useUserFlats } from 'services/contracts/hooks/useUserFlats'

const REPORTABLE_CONTRACT_STATUSES = [
  CONTRACT_STATUS.contractStatusActivationReady,
  CONTRACT_STATUS.contractStatusTypeActive,
  CONTRACT_STATUS.contractStatusDepositPaid,
  CONTRACT_STATUS.contractStatusEnded
]

// A user can report a fault when they have a reportable, non-frozen contract
// or an owner flat whose investment is not operations-frozen.
export const useCanReportFault = () => {
  const { isLoading, canReportFaults, leaseContractsList } = useLeaseContractsList()
  const userRoles = useUserRoles()
  const isOwnerUser = isOwner(userRoles)
  const { userFlats } = useUserFlats()

  const hasNonFrozenContract = leaseContractsList.some(
    ({ leaseStatus, isOperationsFrozen }) =>
      !isOperationsFrozen && REPORTABLE_CONTRACT_STATUSES.includes(leaseStatus)
  )

  const hasNonFrozenOwnerFlat = Boolean(
    isOwnerUser &&
      userFlats &&
      userFlats.some(
        (flat) => flat.connectionType === 'owner' && !flat.investment?.operationsFrozen
      )
  )

  return {
    canReportFault: (canReportFaults && hasNonFrozenContract) || hasNonFrozenOwnerFlat,
    isLoading
  }
}
